import { CLSTAG } from '@/utils/constant';
import { clstagStr } from '@/utils/util';
import classNames from 'classnames';
import React, { useState } from 'react';

const JiraKey = ({ disable }: { disable: boolean }) => {
  return (
    <>
      <div
        className={classNames('', {
          'operate-jira': !disable,
          'operate-jira-disabled': disable,
        })}
        clstag={clstagStr(CLSTAG.JiraReport)}
      />

      <h3 className='operate_key'>提报缺陷</h3>
    </>
  );
};
export default JiraKey;
